import {Injectable} from '@angular/core';
import { Blames } from '@shared/src/enums/Blames'

@Injectable()
export class ChangeBlameDto {
	public message: string;
    public blame: Blames;
}
